// @flow strict
import { api as appApi } from '@/core/api';
import type { UserSettingsType } from '@/model/User/UserSettings';

export const getCurrentUserSettings = (): Promise<UserSettingsType> => {
    return appApi<UserSettingsType, void>('GET', 'settings');
};
